/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { TTableColumnCell } from '../../../types';
import { TableCell } from '../index';
import TableCellNoValue from '../TableCellNoValue';
import BalanceCell from './BalanceCell';
import { TTableCellBalance } from './types';

function TableCellBalance<D extends object>(cell: TTableCellBalance<D>): Pick<TTableColumnCell<D>, 'Cell' | 'align' | 'rowCount'> {

    return {
        Cell: props => TableCell(props)({
            render: ({ row }) => {
                const { currency, date, value } = cell(row);
                return value || date
                    ? <BalanceCell currency={currency} date={date} value={value || 0}/>
                    : <TableCellNoValue/>;
            },
        }),
        align: 'right',
        rowCount: 2,
    };
}

export default TableCellBalance;
